module.exports = __webpack_public_path__ + "static/img/head_img3.7e83af5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my/head_img3.jpg
// module id = rI3m
// module chunks = 1